export const NAV_LINKS = [
  { to: '/', label: 'Ana Sayfa' },
  { to: '/hesaplama', label: 'Hesaplama' },
  { to: '/hakkimizda', label: 'Hakkımızda' },
  { to: '/bilgilendirme', label: 'Bilgilendirme' },
  { to: '/yasal-uyari', label: 'Yasal Uyarı' },
  { to: '/iletisim', label: 'İletişim' },
] as const
